import apiService from './apiService';

class ContractTypeService {
  async getAll() {
    return await apiService.get('/contracttypes');
  }

  async getById(id) {
    return await apiService.get(`/contracttypes/${id}`);
  }

  async create(contractTypeData) {
    return await apiService.post('/contracttypes', contractTypeData);
  }

  async update(id, contractTypeData) {
    return await apiService.put(`/contracttypes/${id}`, contractTypeData);
  }

  async delete(id) {
    return await apiService.delete(`/contracttypes/${id}`);
  }
}

const contractTypeService = new ContractTypeService();
export default contractTypeService;
